/**
 * TAB_STORAGE_MAP allows you to map logical keys (e.g. 'cabinet', 'vehicle', 'packout')
 * to session storage names for per-tab state isolation. For example:
 *   cabinet: 'cabinet-design-session-storage',
 *   vehicle: 'vehicle-storage-session-storage',
 *   packout: 'packout-session-storage'
 *
 * When you call setTabState(updates, TAB_STORAGE_MAP.vehicle),
 * the tab state will be stored in window.__tabVehicleStorageSessionStorage for that tab.
 * Similarly, TAB_STORAGE_MAP.packout will use window.__tabPackoutSessionStorage.
 *
 * This makes it easy to debug and inspect per-tab state for any module in the browser.
 * Just look for the corresponding window object.
 */
// Logical key to window object name mapping
const TAB_STORAGE_MAP = {
  cabinet: 'cabinet-design-session-storage',
  // Add more logical keys and storage names as needed
};

function getWindowPropName(storageName) {
  return '__tab' + storageName
    .replace(/[^a-zA-Z0-9]+/g, ' ') // replace non-alphanum with space
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

const TAB_KEYS = [
  'currentProjectId',
  'designIds',
  'designs',
  'selectedDesignId',
  'styleChoiceId',
  'userSelectedCollection'
];

function getTabKey() {
  if (typeof window !== 'undefined') {
    if (!window.name) window.name = `tab-${Math.random().toString(36).substr(2, 9)}`;
    return window.name;
  }
  return 'default';
}

function getTabState(storageName = TAB_STORAGE_MAP.cabinet) {
  const key = getTabKey();
  if (typeof window !== 'undefined') {
    const winProp = getWindowPropName(storageName);
    if (!window[winProp]) window[winProp] = {};
    return window[winProp][key] || {};
  }
  return {};
}

function setTabState(updates, storageName = TAB_STORAGE_MAP.cabinet) {
  const key = getTabKey();
  if (typeof window !== 'undefined') {
    const winProp = getWindowPropName(storageName);
    if (!window[winProp]) window[winProp] = {};
    window[winProp][key] = {
      ...window[winProp][key],
      ...updates
    };
  }
}

function getTabValue(field, storageName = TAB_STORAGE_MAP.cabinet) {
  return getTabState(storageName)[field];
}

function setTabValue(field, value, storageName = TAB_STORAGE_MAP.cabinet) {
  setTabState({ [field]: value }, storageName);
}

export {
  TAB_KEYS,
  TAB_STORAGE_MAP,
  getWindowPropName,
  getTabState,
  setTabState,
  getTabValue,
  setTabValue
};
